<template>
  <div data-v-600960a6="" data-v-12b14801="" class="mien">
    <ul data-v-600960a6="" class="nav">
      <li data-v-600960a6="" @click="changNav(0)" :class="nav == 0 ? 'tab active' : 'tab'">{{$store.state.appInfo.title}}赞助</li>
      <li data-v-600960a6="" @click="changNav(1)" :class="nav == 1 ? 'tab active' : 'tab'">品牌历程</li>
    </ul>
    <div data-v-600960a6="" class="main" v-if="nav == 0">
      <div data-v-7d1a9adc="" data-v-600960a6="" class="main">
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/2021xmaskf.7cfc4129.png" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/2021xmaskf.7cfc4129.png" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">代言人圣诞祝福</span><span data-v-7d1a9adc="" class="date">2021年12月</span></div>
            <p data-v-7d1a9adc="" class="desc">卢卡斯 &amp; 斯内德祝福您圣诞快乐</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/34.41ceb898.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/34.41ceb898.jpg" lazy="loaded" /><!----></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">韦斯利・斯内德祝大家中秋快乐</span><span data-v-7d1a9adc="" class="date">2021年9月</span></div>
            <p data-v-7d1a9adc="" class="desc">斯内德向{{$store.state.appInfo.title}}全体会员献上中秋祝福</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/33.c8c34d2d.png" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/33.c8c34d2d.png" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}正式签约卢卡斯 &amp; 斯内德</span><span data-v-7d1a9adc="" class="date">2021年6月</span></div>
            <p data-v-7d1a9adc="" class="desc">成为{{$store.state.appInfo.title}}品牌代言人</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/32.f2211091.png" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/32.f2211091.png" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}与您一直都在</span><span data-v-7d1a9adc="" class="date">2020年4月</span></div>
            <p data-v-7d1a9adc="" class="desc">加油世界，加油卡利亚里。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/31.a747537a.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/31.a747537a.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}赞助足总杯 谢周三VS曼城</span><span data-v-7d1a9adc="" class="date">2020年3月</span></div>
            <p data-v-7d1a9adc="" class="desc">一起为武汉加油</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/30.7f99aef1.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/30.7f99aef1.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}正式签约意甲卡利亚里足球俱乐部</span><span data-v-7d1a9adc="" class="date">2020年2月</span></div>
            <p data-v-7d1a9adc="" class="desc">成为官方合作伙伴</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/28.98bc6e88.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/28.98bc6e88.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">为武汉加油 与{{$store.state.appInfo.title}}携手捐赠</span><span data-v-7d1a9adc="" class="date">2020年1月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}梦想基金助力湖北捐赠200万元人民币</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/29.83b34cae.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/29.83b34cae.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}捐赠物资对抗菲律宾百年火山灾害</span><span data-v-7d1a9adc="" class="date">2020年1月</span></div>
            <p data-v-7d1a9adc="" class="desc">爱心传递公益先行</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/27.8904d62f.png" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/27.8904d62f.png" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">2020德甲劲旅，{{$store.state.appInfo.title}}合作伙伴</span><span data-v-7d1a9adc="" class="date">2020年01月</span></div>
            <p data-v-7d1a9adc="" class="desc">沙尔克04给您拜年</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/26.04e3947b.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/26.04e3947b.jpg" lazy="loaded" /><!----></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">陈小春STOP ANGRY 巡回演唱会</span><span data-v-7d1a9adc="" class="date">2019年11月</span></div>
            <p data-v-7d1a9adc="" class="desc">赞助陈小春演唱会</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/25.d924a62c.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/25.d924a62c.jpg" lazy="loaded" /><!----></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}正式签约菲律宾及马尔代夫国家队</span><span data-v-7d1a9adc="" class="date">2019年8月及9月</span></div>
            <p data-v-7d1a9adc="" class="desc">成为官方合作伙伴</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/video_4.bb15b569.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/video_4.bb15b569.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">2019—2020沙尔克04新赛季</span><span data-v-7d1a9adc="" class="date">2019年08月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}助力沙尔克04再创佳绩</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/video_3.277db5f3.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/video_3.277db5f3.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}} 倾情赞助</span><span data-v-7d1a9adc="" class="date">2019年08月</span></div>
            <p data-v-7d1a9adc="" class="desc">谢周三VS西班牙人友谊赛，取得圆满成功</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/video_2.aadb0a45.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/video_2.aadb0a45.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}梦想基金2019赞助立昊杯</span><span data-v-7d1a9adc="" class="date">2019年05月</span></div>
            <p data-v-7d1a9adc="" class="desc">梦想再起航，为足球少年撑起梦想风帆</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/video_1.727866a8.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/video_1.727866a8.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">相约沙尔克04，{{$store.state.appInfo.title}}伴您行</span><span data-v-7d1a9adc="" class="date">2019年05月</span></div>
            <p data-v-7d1a9adc="" class="desc">矿工魅力 {{$store.state.appInfo.title}}演绎</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/10.5ac8e638.jpg" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" lazy="loading" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">燃情沙尔克 {{$store.state.appInfo.title}}伴您行</span><span data-v-7d1a9adc="" class="date">2019年02月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}邀请知名足球记者与球迷前往德国独享参观俱乐部</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/9.8cd7b7cd.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/9.8cd7b7cd.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}梦想基金赞助21号足球场 </span><span data-v-7d1a9adc="" class="date">2019年01月</span></div>
            <p data-v-7d1a9adc="" class="desc">群星祝贺顺利竣工</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/8.200f67a5.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/8.200f67a5.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}赞助沙尔克04-小球员梦想之旅 </span><span data-v-7d1a9adc="" class="date">2018年10月</span></div>
            <p data-v-7d1a9adc="" class="desc">让青少年足球梦想插上翅膀远飞德国</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/7.b761adb2.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/7.b761adb2.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">世界杯冠军Henry（亨利）正式成为{{$store.state.appInfo.title}}代言人</span><span data-v-7d1a9adc="" class="date">2018年8月</span></div>
            <p data-v-7d1a9adc="" class="desc">法国足球历史上进球最多的球员</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/6.78a2b360.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/6.78a2b360.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">跟着{{$store.state.appInfo.title}}看沙尔克04</span><span data-v-7d1a9adc="" class="date">2018年5月</span></div>
            <p data-v-7d1a9adc="" class="desc">女神带您亲临现场，一起做矿工吧！</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/2.ddf1f8aa.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/2.ddf1f8aa.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}赞助周杰伦地表最强2世界巡回演唱会</span><span data-v-7d1a9adc="" class="date">2018年1月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}赞助周杰伦地表最强2世界巡回演唱会-香港站，邀请百位会员一同感受地表最强的演唱会</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box">
            <img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/3.0d4b8ef5.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/3.0d4b8ef5.jpg" lazy="loaded" /><span data-v-7d1a9adc="" class="icon-play"></span>
          </div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}与曼城联合举办球迷见面会</span><span data-v-7d1a9adc="" class="date">2017年11月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}与曼城俱乐部联合举办中国深圳球迷见面会，产生的幸运儿可直飞英国现场观赛。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/24.6719669f.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/24.6719669f.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">AG{{$store.state.appInfo.title}}之夜-FHM男人装泳池派对</span><span data-v-7d1a9adc="" class="date">2017年11月</span></div>
            <p data-v-7d1a9adc="" class="desc">龙门会成员独享AG{{$store.state.appInfo.title}}之夜-FHM男人装泳池派对。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/4.7bbb499e.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/4.7bbb499e.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}正式签约卡迪夫城足球俱乐部</span><span data-v-7d1a9adc="" class="date">2017年9月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}2017年9月正式宣布成为卡迪夫城足球俱乐部的独家博彩合作伙伴，{{$store.state.appInfo.title}}将在未来的一年全力支持卡迪夫城足球俱乐部。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/23.bfcf931d.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/23.bfcf931d.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}正式签约曼城及沙尔克04</span><span data-v-7d1a9adc="" class="date">2017年6月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}正式宣布成为英超曼城及德甲沙尔克04唯一博彩行业合作伙伴-亚洲区，{{$store.state.appInfo.title}}将在未来一年全力支持英超曼城及德甲沙尔克04。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/22.288871b6.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/22.288871b6.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}赞助西布朗俱乐部举办足球宝贝大赛</span><span data-v-7d1a9adc="" class="date">2017年3月</span></div>
            <p data-v-7d1a9adc="" class="desc">2017{{$store.state.appInfo.title}}赞助西布朗俱乐部举办中国区的足球宝贝大赛，表彰对英超联赛和西布朗足球俱乐部有传播、有影响力的女性足球宝贝代表。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/13.a9fc8297.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/13.a9fc8297.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}冠名罗志祥</span><span data-v-7d1a9adc="" class="date">2016年12月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}冠名罗志祥Crazy World疯狂世界巡回演唱会香港站，邀请百位会员一同来到疯狂世界。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/12.1dee7d0f.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/12.1dee7d0f.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">全民健身日“{{$store.state.appInfo.title}}杯”足球慈善赛</span><span data-v-7d1a9adc="" class="date">2016年</span></div>
            <p data-v-7d1a9adc="" class="desc">“{{$store.state.appInfo.title}}”- 爱满人间 情暖人心-心连心同献爱心,手牵手齐伸援手梅州中学30名足球特困生进行捐资助学。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/5.fc0850c0.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/5.fc0850c0.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}正式宣布成为英超球队西...</span><span data-v-7d1a9adc="" class="date">2016年7月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}正式宣布成为英国超级联赛老牌俱乐部-西布罗姆维奇官方主赞助商，简称西布朗，{{$store.state.appInfo.title}}也将在未来一年全力支持西布朗。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/11.8e927de6.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/11.8e927de6.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}赞助陈奕迅跨年演唱会澳门站</span><span data-v-7d1a9adc="" class="date">2015年12月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}赞助陈奕迅2015-2016 ANOTHER EASONS LIFE 跨年演唱会澳门站，邀请百位会员一同领略歌神风采。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/16.189af18b.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/16.189af18b.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">美洲杯：唯一在线博彩官方赞助商（亚洲区）</span><span data-v-7d1a9adc="" class="date">2015年3月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}，看得见的实力！{{$store.state.appInfo.title}}不断在各种国际性赛事中，拓展我们的品牌影响力，只为让您因{{$store.state.appInfo.title}}而倍感自豪！</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/14.a70262de.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/14.a70262de.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}品牌大使：米夏埃尔·巴拉克</span><span data-v-7d1a9adc="" class="date">2015年2月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}与前德国国家队队长、德国足球先生、世界著名球星巴拉克先生共进2015</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/15.6d13527a.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/15.6d13527a.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}荣誉赞助第三届老甲A</span><span data-v-7d1a9adc="" class="date">2014年11月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}荣誉赞助，重温经典，黄金一代。第三届老甲A，11月20日陕西西安完美收官。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/19.900b76d8.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/19.900b76d8.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}携手巴拉克共赢世界杯</span><span data-v-7d1a9adc="" class="date">2014年4月</span></div>
            <p data-v-7d1a9adc="" class="desc">{{$store.state.appInfo.title}}与前德国国家队队长、德国足球先生、世界著名球星巴拉克先生签署代言协议，特聘巴拉克先生为{{$store.state.appInfo.title}}的巴西世界杯形象大使。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/18.914d7f87.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/18.914d7f87.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}独家赞助的昆仑决4</span><span data-v-7d1a9adc="" class="date">2014年4月</span></div>
            <p data-v-7d1a9adc="" class="desc">由{{$store.state.appInfo.title}}独家赞助的昆仑决4马尼拉站落幕，美女黄飞儿惊艳KO对手。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/17.03b13752.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/17.03b13752.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">AV女优荷官周</span><span data-v-7d1a9adc="" class="date">2014年1月</span></div>
            <p data-v-7d1a9adc="" class="desc">让您了解不一样的波多野结衣，由AG平台鼎力支持。</p>
          </div>
        </div>
        <div data-v-7d1a9adc="" class="list-box">
          <div data-v-7d1a9adc="" class="img-box"><img data-v-7d1a9adc="" data-src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/21.9b46924f.jpg" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/21.9b46924f.jpg" lazy="loaded" /></div>
          <div data-v-7d1a9adc="" class="info">
            <div data-v-7d1a9adc="" class="title"><span data-v-7d1a9adc="" class="title-content">{{$store.state.appInfo.title}}激情襄助兰博基尼</span><span data-v-7d1a9adc="" class="date">2013年11月</span></div>
            <p data-v-7d1a9adc="" class="desc">襄情赞助“兰博基尼亚洲挑战赛”，与您相约澳门。</p>
          </div>
        </div>
        <!----><!----><!----><!---->
      </div>
    </div>
    <div data-v-600960a6="" class="main" v-if="nav == 1">
      <div data-v-e6fd6dd0="" data-v-600960a6="" class="main">
        <div data-v-e6fd6dd0="" class="history">
          <ul data-v-e6fd6dd0="" class="list">
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner44.577fca0f.png" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}正式收购乐橙娱乐</div>
                  <p data-v-e6fd6dd0="">2021年9月</p>
                  <p data-v-e6fd6dd0="" class="desc">携手共赢 实力见证</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner43.e2edcd85.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">2019{{$store.state.appInfo.title}}年度传记</div>
                  <p data-v-e6fd6dd0="">2020年2月</p>
                  <p data-v-e6fd6dd0="" class="desc">2019{{$store.state.appInfo.title}}年度报告，感谢会员一路相随</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner42.2bf4d21f.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}正式收购暴风竞技</div>
                  <p data-v-e6fd6dd0="">2020年2月</p>
                  <p data-v-e6fd6dd0="" class="desc">博彩行业全方位多元化布局</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner41.4c6e8f88.jpg" /><span data-v-e6fd6dd0="" class="icon-play"></span></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}第二届「{{$store.state.appInfo.title}}赌王」诞生</div>
                  <p data-v-e6fd6dd0="">2019年10月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}带您一睹赌王绰约风姿</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner40.335d7306.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}正式更换Logo</div>
                  <p data-v-e6fd6dd0="">2019年10月</p>
                  <p data-v-e6fd6dd0="" class="desc">全新升级上线</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner39.cb432b79.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}直播室首家进驻AG旗舰厅</div>
                  <p data-v-e6fd6dd0="">2019年08月</p>
                  <p data-v-e6fd6dd0="" class="desc">与美女主播一起游戏</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner37.29dbb1e8.png" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">AG平台首家开设200万限红</div>
                  <p data-v-e6fd6dd0="">2019年05月</p>
                  <p data-v-e6fd6dd0="" class="desc">至尊体验 豪客首选</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/annualreport2018.0cae710f.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}年度传记</div>
                  <p data-v-e6fd6dd0="">2019年1月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}2018年度传记</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/usdtnew.6ff92b21.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}支持USDT账户</div>
                  <p data-v-e6fd6dd0="">2018年10月</p>
                  <p data-v-e6fd6dd0="" class="desc">首家支持USDT账户，安全且方便</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/2018hyxf.5faf3416.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}成功收购悦博体育</div>
                  <p data-v-e6fd6dd0="">2018年10月</p>
                  <p data-v-e6fd6dd0="" class="desc">成行业先锋</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/voice.8705829f.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">行业首推APP语言通话正式上线</div>
                  <p data-v-e6fd6dd0="">2018年7月</p>
                  <p data-v-e6fd6dd0="" class="desc">沟通无障碍，紧跟互连网脚步，全面推出语音通话服务，让您和朋友一样聊天。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/dream.4026162f.png" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}梦想基金-球场援建项目</div>
                  <p data-v-e6fd6dd0="">2018年2月</p>
                  <p data-v-e6fd6dd0="" class="desc">为中国偏远地区的学校建设球场、捐献物资装备，为青少年放飞足球梦想保驾护航。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/yeb.b4be49bb.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}过夜利息-正式推出</div>
                  <p data-v-e6fd6dd0="">2018年2月</p>
                  <p data-v-e6fd6dd0="" class="desc">为感谢广大的客户一路相随，{{$store.state.appInfo.title}}正式推出过夜利息，年利率高达18%，转入金额无上限，无需任何流水，金额越大赚越多。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/annaulr.d2273b67.png" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">2017年{{$store.state.appInfo.title}}年度报告</div>
                  <p data-v-e6fd6dd0="">2018年1月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}以公平、透明的方式将报表公示给每一位玩家让您更了解您所依赖的平台。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/bitcoin.73ea100f.png" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}正式推出比特币存取款</div>
                  <p data-v-e6fd6dd0="">2018年1月</p>
                  <p data-v-e6fd6dd0="" class="desc">24小时即充即玩 史上最快最安全的充值方式 分秒到帐。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/dreamfundation.a52e23d4.png" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}梦想基金-恭喜{{$store.state.appInfo.title}}梦想基金正式成立。</div>
                  <p data-v-e6fd6dd0="">2017年12月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}梦想基金是在海外侨胞华人等各届热心人士的支持下，为回馈社会、助力青少年体育事业发展所成立的慈善公益基金。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/fcircle.bea385fd.png" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}朋友圈正式上线</div>
                  <p data-v-e6fd6dd0="">2017年12月</p>
                  <p data-v-e6fd6dd0="" class="desc">优惠、攻略、战绩 不可错过的精彩。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner31.4195fd78.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}手机APP全新上线-支持安卓、苹果系统</div>
                  <p data-v-e6fd6dd0="">2017年5月</p>
                  <p data-v-e6fd6dd0="" class="desc">游戏大厅一应俱全，让您随时随地畅赢{{$store.state.appInfo.title}}，存取款、洗码等功能一步到位，让您一次下载，一生永久享用。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner30.5419d629.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">2017{{$store.state.appInfo.title}}网页版</div>
                  <p data-v-e6fd6dd0="">2017年5月</p>
                  <p data-v-e6fd6dd0="" class="desc">全新改版，震撼来袭，2017年{{$store.state.appInfo.title}}将以最简约并高实用性的设计给您视觉上的冲击，颠覆您的想象。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner28.505ad04c.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">行业首推APP语音客服正式上线</div>
                  <p data-v-e6fd6dd0="">2017年4月</p>
                  <p data-v-e6fd6dd0="" class="desc">灵犀语音，无需打字，随时随地，随心互动。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner26.f70839bb.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">行业内首推年度报告</div>
                  <p data-v-e6fd6dd0="">2017年1月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}2016年度报告，数据公正透明，玩家游戏放心。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner2.713683bf.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">2016百家乐赌王现场争霸赛</div>
                  <p data-v-e6fd6dd0="">2016年6月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}第一届赌王即将诞生，让我们一起见证此证辉煌时刻，一睹赌王卓越风姿。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner10.fad5d136.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}手机APP全新上线</div>
                  <p data-v-e6fd6dd0="">2016年3月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}手机用户量日渐增多，为了最大限度的满足手机用户，隆重推出{{$store.state.appInfo.title}}手机APP。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner9.91937558.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}网站全新改版 用户体验再次升级</div>
                  <p data-v-e6fd6dd0="">2015年4月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}历时10个月的精心准备及筹划，终于迎来了第三代新版本的发布，让我们与您携手共进，{{$store.state.appInfo.title}}有您更精彩！</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner18.9160e73e.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">网站正式开通比特币充值业务</div>
                  <p data-v-e6fd6dd0="">2014年5月</p>
                  <p data-v-e6fd6dd0="" class="desc">盈码比例全面上浮0.1%，您可能不是最明智的，但一定是最有远见的。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner11.81e93a68.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}，看得见的实力</div>
                  <p data-v-e6fd6dd0="">2014年5月</p>
                  <p data-v-e6fd6dd0="" class="desc">盈利保证金由20,000比特币升至40,000比特币，价值超过1亿2000万人民币。财富公开验证，敢为人先，首家对大客户提供存款“对保”。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner19.60e9f7ca.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}LOGO正式更换</div>
                  <p data-v-e6fd6dd0="">2014年3月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}LOGO正式更换，只因有您，我们更卓越。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner22.403c1e92.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">利博亚洲正式更名为{{$store.state.appInfo.title}}</div>
                  <p data-v-e6fd6dd0="">2013年10月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}，与您一起继续见证利博亚洲的进步。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner20.0b026a39.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">积分商城正式登场</div>
                  <p data-v-e6fd6dd0="">2013年8月</p>
                  <p data-v-e6fd6dd0="" class="desc">我们的愿望：轻松游戏，关爱家人。用心做服务，与您一起关爱家人。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner25.92faee1f.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">TeamViewer</div>
                  <p data-v-e6fd6dd0="">2013年7月</p>
                  <p data-v-e6fd6dd0="" class="desc">为客户提供TeamViewer远程服务，游戏无忧。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner24.3217066f.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">{{$store.state.appInfo.title}}专用浏览器正式发布</div>
                  <p data-v-e6fd6dd0="">2013年6月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}专用浏览器正式发布，速度无忧。让您游戏无忧。随心所欲。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner23.01bf1905.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">行业首创6张牌先发</div>
                  <p data-v-e6fd6dd0="">2013年6月</p>
                  <p data-v-e6fd6dd0="" class="desc">{{$store.state.appInfo.title}}与亚游集团同时发布“6张牌先发”。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner21.ac5d39cd.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">玩家单日取款限额升至800万</div>
                  <p data-v-e6fd6dd0="">2013年2月</p>
                  <p data-v-e6fd6dd0="" class="desc">支持澳门赌场提现，高达2000万RMB。</p>
                </div>
              </div>
            </li>
            <li data-v-e6fd6dd0="">
              <div data-v-e6fd6dd0="" class="dot-h"><span data-v-e6fd6dd0="" class="dot"></span></div>
              <div data-v-e6fd6dd0="" class="details">
                <div data-v-e6fd6dd0="" class="img-box"><img data-v-e6fd6dd0="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/banner4.e58ea269.jpg" /></div>
                <div data-v-e6fd6dd0="" class="info">
                  <div data-v-e6fd6dd0="" class="title">行业首家推出包桌百家乐</div>
                  <p data-v-e6fd6dd0="">2013年2月</p>
                  <p data-v-e6fd6dd0="" class="desc">首家引进“包桌咪牌百家乐”，集结“网络”与“陆地”赌场的双重优势，至尊体验。</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!----><!---->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sponsor',
  data() {
    return { nav: 0 };
  },
  created() {
    let that = this;
  },
  methods: {
    changNav(val) {
      this.nav = val;
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.common-banner .common-bannerimg[data-v-600960a6] {
  display: block;
  width: 100%;
  height: auto;
  margin-top: 0;
  margin-right: auto;
  margin-bottom: 0;
  margin-left: auto;
}
.left-label[data-v-600960a6] {
  display: block;
  height: 0.25rem;
  margin-bottom: 0.1rem;
  font-size: 0.18rem;
  font-weight: 700;
  line-height: 0.25rem;
  color: #333;
}
.order-list[data-v-600960a6] {
  width: auto;
  height: auto;
  padding: 0;
  padding-left: 0.28rem;
  margin: 0 0 0.2rem 0;
  font-size: 0.14rem;
  color: #666;
  list-style-type: decimal-leading-zero;
}
.order-list li[data-v-600960a6] {
  display: list-item;
  height: auto;
  padding-left: 0.1rem;
  margin-bottom: 0.1rem;
  line-height: 0.28rem;
}
.gray-con[data-v-600960a6] {
  width: auto;
  padding: 0.2rem 0.15rem 0.3rem 0.15rem;
  padding-bottom: 0.3rem;
  margin: 0 auto;
  background-color: #f5f5f5;
}
.center-text[data-v-600960a6] {
  margin: 0 auto 0.15rem;
  font-size: 0.14rem;
  line-height: 0.25rem;
  color: #666;
}
.table-con[data-v-600960a6] {
  margin: 0 auto 0.3rem;
  overflow-x: auto;
  border-radius: 4px;
}
.table-con .table[data-v-600960a6] {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  border: 1px solid #faf0e0;
}
.table-con .table tr:first-child th[data-v-600960a6] {
  border-top: none;
}
.table-con .table th[data-v-600960a6] {
  padding-top: 0.11rem;
  padding-bottom: 0.11rem;
  font-size: 0.14rem;
  font-weight: 400;
  color: #333;
  white-space: nowrap;
  background-color: #fcf7ef;
  border-color: #fcf7ef;
  border-bottom: none;
}
.table-con .table th[data-v-600960a6]:first-child {
  padding-left: 0.1rem;
  border-left: none;
}
.table-con .table th[data-v-600960a6]::last-child {
  padding-right: 0.1rem;
  border-right: none;
}
.table-con .table td[data-v-600960a6] {
  padding: 2.66667vw 2.13333vw;
  font-size: 3.73333vw;
  font-size: 0.14rem;
  font-weight: 400;
  line-height: 1.2;
  color: #666;
  text-align: center;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid #faf0e0;
}
.middle-btn[data-v-600960a6] {
  display: block;
  width: 1.65rem;
  height: 0.52rem;
  margin: 0.1rem auto 0.29rem;
  font-size: 0.16rem;
  line-height: 0.52rem;
  color: #fff;
  text-align: center;
  background-color: #e4b265;
  border-radius: 100px;
}
.input-err-icon[data-v-600960a6] {
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  width: 16px;
  height: 16px;
  background-size: 100%;
  margin-right: 3px;
}
.input-err-border[data-v-600960a6] {
  border-bottom: 1px solid #d91c1c !important;
}
.input-err-text[data-v-600960a6] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #d91c1c !important;
  font-weight: 400;
  margin-top: -3px;
}
.mien[data-v-600960a6] {
  background: #141414;
}
.mien .nav[data-v-600960a6] {
  height: 50px;
  text-align: center;
  background-color: #141414;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
}
.mien .nav .tab[data-v-600960a6] {
  display: inline-block;
  padding: 0 20px;
  overflow: hidden;
  font-size: 15px;
  line-height: 50px;
  color: #fff;
  text-align: center;
}
.mien .nav .tab.active[data-v-600960a6] {
  color: #f9cb5c;
}
.mien .nav .tab.active[data-v-600960a6]:after {
  display: block;
  width: 30px;
  height: 3px;
  margin: -2px auto 0 auto;
  content: '';
  background: #f9cb5c;
  border-radius: 1.5px;
}
.main[data-v-7d1a9adc] {
  padding-bottom: 20px;
}
.main .list-box[data-v-7d1a9adc] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 15px 0 0 0;
  margin: 0 15px;
}
.main .list-box .img-box[data-v-7d1a9adc] {
  position: relative;
  min-height: 130px;
  background-color: #282828;
  border-radius: 8px 8px 0 0;
}
.main .list-box .img-box img[data-v-7d1a9adc] {
  width: 100%;
  border-radius: 8px 8px 0 0;
}
.main .list-box .img-box .icon-play[data-v-7d1a9adc] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 42px;
  height: 42px;
  margin: auto;
  background: url(/static/image/icon-play.663b8348.png) no-repeat;
  background-size: 100% 100%;
}
.main .list-box .title[data-v-7d1a9adc] {
  padding: 0;
  margin-bottom: 5px;
  color: #fff;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 17px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.main .list-box .title .title-content[data-v-7d1a9adc] {
  -webkit-box-flex: 20vw;
  -ms-flex: 20vw;
  flex: 20vw;
}
.main .list-box .date[data-v-7d1a9adc] {
  color: #666;
  font-size: 14px;
  margin-top: 1.5px;
  margin-left: 5px;
  letter-spacing: 0;
  line-height: 15px;
  text-align: right;
}
.main .list-box p[data-v-7d1a9adc] {
  font-size: 14px;
  color: #999;
  letter-spacing: 0;
  line-height: 15px;
}
.main .list-box p.date[data-v-7d1a9adc] {
  color: #666;
}
.main .list-box .info[data-v-7d1a9adc] {
  background-color: #282828;
  border-radius: 0 0 8px 8px;
  padding: 10px;
}
.video-wrap[data-v-7d1a9adc] {
  position: fixed;
  top: 0;
  z-index: 999999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.video-wrap .video-pop[data-v-7d1a9adc] {
  position: relative;
  top: 50%;
  width: 370px;
  max-height: 230px;
  padding: 15px;
  margin: auto auto;
  margin-top: -120px;
  -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.9);
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.9);
}
.video-wrap .video-pop video[data-v-7d1a9adc] {
  width: 100%;
  height: 100%;
}
.video-wrap .video-pop .video-close[data-v-7d1a9adc] {
  position: absolute;
  top: -34px;
  right: 16px;
  display: block;
  float: none;
  width: 27px;
  height: 47px;
  margin: 0 auto;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
.pop-img-backdrop[data-v-7d1a9adc] {
  position: fixed;
  top: 0;
  z-index: 99999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
.pop-img-backdrop .pop-img[data-v-7d1a9adc] {
  position: relative;
  top: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 370px;
  height: 230px;
  padding: 15px;
  margin: auto auto;
  margin-top: -120px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 0.3125em;
  -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.9);
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.9);
}
.pop-img-backdrop .pop-img .close[data-v-7d1a9adc] {
  position: absolute;
  top: -35px;
  right: 15px;
  display: block;
  float: none;
  width: 27px;
  height: 47px;
  margin: 0 auto;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
.pop-img-backdrop .pop-img img[data-v-7d1a9adc] {
  display: block;
  width: 100%;
}
.pop-img-backdrop .pop-img .pop-img-cycle[data-v-7d1a9adc] {
  height: 200px;
  overflow: hidden;
}
.pop-img-backdrop .pop-img .imgh[data-v-7d1a9adc] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}
.pop-img-backdrop .pop-img .icon-play[data-v-7d1a9adc] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 42px;
  height: 42px;
  margin: auto;
  background: url(/static/image/icon-play.663b8348.png) no-repeat;
  background-size: 100% 100%;
}
.pop-img-backdrop .pop-img .swiper-button[data-v-7d1a9adc] {
  position: absolute;
  top: auto;
  bottom: 30px;
  z-index: 100;
  display: block;
  width: 33px;
  height: 33px;
  cursor: pointer;
  outline: 0;
}
.pop-img-backdrop .pop-img .swiper-button.swiper-button-prev[data-v-7d1a9adc] {
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
.pop-img-backdrop .pop-img .swiper-button.swiper-button-next[data-v-7d1a9adc] {
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
.pop-mask[data-v-7d1a9adc] {
  position: fixed;
  top: 0;
  z-index: 99999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
.pop-mask .pop-box[data-v-7d1a9adc] {
  width: 98%;
  height: 230px;
  max-width: 375px;
  background: #fff;
  border-radius: 8px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 8px 0;
}
.pop-mask .pop-box .swiper-container[data-v-7d1a9adc] {
  width: 282px;
  margin: 0 auto;
}
.pop-mask .pop-box .swiper-container .swiper-slide[data-v-7d1a9adc] {
  width: 100%;
}
.pop-mask .pop-box .swiper-container .img[data-v-7d1a9adc] {
  width: 282px;
}
.pop-mask .pop-box img[data-v-7d1a9adc] {
  display: block;
  width: 100%;
}
.pop-mask .pop-box .swiper-button[data-v-7d1a9adc] {
  width: 33px;
  height: 33px;
  top: auto;
  bottom: 30px;
  outline: none;
}
.pop-mask .pop-box .swiper-button.swiper-button-prev[data-v-7d1a9adc] {
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
.pop-mask .pop-box .swiper-button.swiper-button-next[data-v-7d1a9adc] {
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
.pop-mask .pop-box .pop-close[data-v-7d1a9adc] {
  position: absolute;
  top: -35px;
  right: 15px;
  display: block;
  float: none;
  width: 27px;
  height: 47px;
  margin: 0 auto;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
.history[data-v-e6fd6dd0] {
  padding: 15px 0;
  margin: 0 15px 0 28px;
}
.history ul li[data-v-e6fd6dd0] {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: -2px;
  border-left: 2px solid #9a6b3d;
}
.history ul li .dot-h[data-v-e6fd6dd0] {
  position: absolute;
  top: 5px;
  left: -5px;
  padding: 8px 0;
  background: #141414;
}
.history ul li .dot-h .dot[data-v-e6fd6dd0] {
  display: block;
  width: 8px;
  height: 8px;
  background: #c89f51;
  border-radius: 50%;
}
.history ul li .details[data-v-e6fd6dd0] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 0 0 20px 28px;
  margin-left: -2px;
  border-left: 2px solid #c89f51;
}
.history ul li .details .img-box[data-v-e6fd6dd0] {
  margin-bottom: 10px;
}
.history ul li .details .img-box img[data-v-e6fd6dd0] {
  display: block;
  width: 100%;
  min-height: 114px;
  border-radius: 8px;
}
.history ul li .details .img-box .icon-play[data-v-e6fd6dd0] {
  position: absolute;
  top: -46%;
  right: 0;
  bottom: 0;
  left: 6%;
  width: 42px;
  height: 42px;
  margin: auto;
  background: url(/static/iamge/icon-play.663b8348.png) no-repeat;
  background-size: 100% 100%;
}
.history ul li .details .title[data-v-e6fd6dd0] {
  padding: 8px 0 0;
  font-size: 16px;
  line-height: 16px;
  color: #fff;
}
.history ul li .details p[data-v-e6fd6dd0] {
  margin-top: 5px;
  font-size: 12px;
  color: #666;
}
.history ul li .details p.desc[data-v-e6fd6dd0] {
  font-size: 14px;
  line-height: 20px;
  color: #999;
  text-align: justify;
}
.pop-img-backdrop[data-v-e6fd6dd0] {
  position: fixed;
  top: 0;
  z-index: 99999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
.pop-img-backdrop .pop-img[data-v-e6fd6dd0] {
  position: relative;
  top: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 370px;
  height: 230px;
  padding: 15px;
  margin: auto auto;
  margin-top: -120px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 0.3125em;
  -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.9);
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.9);
}
.pop-img-backdrop .pop-img .close[data-v-e6fd6dd0] {
  position: absolute;
  top: -35px;
  right: 15px;
  display: block;
  float: none;
  width: 27px;
  height: 47px;
  margin: 0 auto;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
.pop-img-backdrop .pop-img img[data-v-e6fd6dd0] {
  display: block;
  width: 100%;
}
.pop-img-backdrop .pop-img .pop-img-cycle[data-v-e6fd6dd0] {
  height: 200px;
  overflow: hidden;
}
.pop-img-backdrop .pop-img .imgh[data-v-e6fd6dd0] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}
.pop-img-backdrop .pop-img .icon-play[data-v-e6fd6dd0] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 42px;
  height: 42px;
  margin: auto;
  background: url(/static/iamge/icon-play.663b8348.png) no-repeat;
  background-size: 100% 100%;
}
.pop-img-backdrop .pop-img .swiper-button[data-v-e6fd6dd0] {
  position: absolute;
  top: auto;
  bottom: 30px;
  z-index: 100;
  display: block;
  width: 33px;
  height: 33px;
  cursor: pointer;
  outline: 0;
}
.pop-img-backdrop .pop-img .swiper-button.swiper-button-prev[data-v-e6fd6dd0] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDYyNTRDRkFDQkQyMTFFOTgwRTlDMkVFQTY4RkE0QkMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTI1NjQ2RThDQkQ0MTFFOTgwRTlDMkVFQTY4RkE0QkMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NjI1NENGOENCRDIxMUU5ODBFOUMyRUVBNjhGQTRCQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NjI1NENGOUNCRDIxMUU5ODBFOUMyRUVBNjhGQTRCQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlnQVEIAAAcoSURBVHja3Jx7TNtVFMdvCwVWGNDBYDjE4VZAt1X+AEdkPEZH0bm4xEwXnTHzmRg1M0FMpuGPJibLkA1hToSFQRZNNnV/zLAZ1Gl0iI+5hCF7UJ5NV6CsA2Utb5jn0Ptrfq0dtPB7tSf5hvAr7b33w73n3HvuvZWlpaURAWwtaBMoBZQEug+kAkWAlPRvxkA20D+gAVAfyABqB5n5rmAwT58rB2WACkHZoDgv3qOkiqPA8livDYF+BX0P+gs0x3WFZRz3CGzEHtDjoHieICOUb0FfgixSA5EIegm0A6Qgwtg06DyoHnRzuR8WFBsbu5z3Y1d+A/Qh6CH8PCKcYVn4X3yG+po2CmfJY3mptg30NehFgQF4AvICrUuBkD0iFPQ+6G1QOJGOhVPnjL7pD9Asnz1iDR2Tu4h0bRet4xq+QGBIa6A/pW4+19VbEA+DakCxxH8sltZ5E1cgNoA+Ba0k/mdY50+86RmLgcAJUhUNT/5qWPePF5vdLgQizJsP8BOLo20JWwqIEj9xjL440Pd8BbFN4iFyqfYUbZtXIJS0NwSqlbCW/guCeE0KfqGoqCjy4sWLm5ubmzU6nS6SY3/x+mKrz/vpnD1IbAjl5eUbgoODZfi71WqdysnJ+ZvDInD6vRtkuleP2Cc2BK1WG1lWVraegYAWEhIi57iYINpWj0MjnuYTRLPc3NyVhw8fXs9u+N27d8mRI0dMPBS3g7CSR2wQewRMqvzPtm7dGlFZWbkhNDTUBQIMEePp06eHeShSQdvsAgJzlzvFgpCVlRWOEMLCwlwgHD161HTixAkrj0XvpG13gngUtEoMCBkZGcpjx46plUqli2+CZzerq6uHeC4e25zJBlEgBoT09HQlNDbFHUJtba0ZQFgEqoaWDSJLaAgajWZFTU2NOiIiwgVCfX19f0VFxaCQI5MBsdbXbM5ybePGjWHHjx9PiYyMdNlXOXny5ACEzgGB/yfY9rVybxMXXFlqaqpHCKdOnRo8ePBgv0j+ehOCSBWqNLVaHVpXV6dWqVQuYfrMmTMWvV5vJuKZGkE8IERJycnJIQAhJSYmJoT9/OzZs0OlpaU3ibiWLCf8bc05LSkpKQScYMrq1atdIJw7d8564MABE84ZRLY1CCKKzxISExMVDQ0NKfHx8aHs501NTbdLSkqMEoCAFiP3tDbn0g4dOrQuISHBBcKFCxduFxcXSwXCfA6GdxAQKl0Svzdu3LDv37/fODs7KxkKDAhebXh4eNotfIbv3bs3hkjLpnHv83myQHZ3udbV1TVWVFS0iskvyGQykp2dHTU6OjrV1tY2LhEQdgSB2+q8bd6YTKap69ev2wsLC1UsGDJYdkcNDQ1NXLt2bUICIIYRxJOE5608o9E4hT0DYQQFBTlh5OfnRw8ODk4AKLFhmBEEnnFax3dJPT09k729vePbt29XyeVyJ4y8vLzo/v7+8Y6ODjFhXEUQmL19RIjSoFdMwlAZKygocMLAn9AzVH19fWP4ukggfkYQ0cyaXAgzGAyTOBxwWLBhIJzu7m47SAwYXyEI7JLPCVkqzCUmLBbLPAwcHvgMfQfC6OzstMMQmhIYRBWCuEMc23uC7nijgxwZGZnMyclxwsCootVqVRBJbOhgBaoKZsI+Y85QPUgcJ9QEtfb29nGbzTYFoTSaspiHAdFlFbxmw9ArQDV+AP3CgJgBPSGGl7py5cq43W6fhkmWCwyMLvDaHbPZPM1zFfAQjIkBgemxp0ErxIDR2to6NjMzM7tly5YoBoZCoZDrdDrV5cuXRwcGBviCgfslZaA5BgSebVYJFUY9GTTYDqvReRjMMwZGc3Pzv1ardYaPaAH6bd5Zs85Z9oGeJSLufV66dMkO0WMuMzPTufuN23+wjFc0NjaOcL3QApXiOmM+hLt5z/NiT/qrqqosdXV1LklcZlrOsZ0nrEPt7idve4njbLNcTBgtLS028BVzGo0mHKbfk3q93nTr1i0uhwYeC8DTw6PMA0+n898hjrPNgWxfgCrYDzz952uJ405EoBq2rcb9oScQeKXoowAGUU7buCgItJ9A3wQgBGzTj55eWMgp4kTDEEAQDLRNxFcQuCp9FzQSABCwDcW0TT6DQMN4/hZxXEP0V7PRNiy4y+7NfKED9CY75vqRjVIIHYv9obcTp6ugVwmH1wsFyjNgndu9+WNfZpA9oFf8xIEaKIQeb9/g61Qaj/TsI47Lp1IOkS8v5hPcbSm3/HCejteTO0HpRDo3/XDGqCeOu1w+r0uWs7jCSReeZ/6c+Hi1kGObpWuH3feaLPHVI9zX9L+Dmogju7VewHwGlt0I+oCWv6wsFteX5PH0DSZ3MP8Zx+MQkOwleU9DDr82QQd6jAMo2PgW0HeEp69N4Ov7I7Cif1Kh4VnOzcRxrwoPryUQR44UHa2SOjdcEeIei516fCMNg3hPg/cTd/8JMACXsh/TtqefOwAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 100% 100%;
}
.pop-img-backdrop .pop-img .swiper-button.swiper-button-next[data-v-e6fd6dd0] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTI1NjQ2RUZDQkQ0MTFFOTgwRTlDMkVFQTY4RkE0QkMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTI1NjQ2RjBDQkQ0MTFFOTgwRTlDMkVFQTY4RkE0QkMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxMjU2NDZFRENCRDQxMUU5ODBFOUMyRUVBNjhGQTRCQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxMjU2NDZFRUNCRDQxMUU5ODBFOUMyRUVBNjhGQTRCQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnYiftcAAAb5SURBVHja3Jx7TNtVFMdveTmYDFoRNl4z0bi5DV2MW8hg4f1wTVxwotMYBDpcCK8lOAhCQhYcfwgJxhgT/3IkotH41zJnqmFLSEDcyDKQDmiB8SrINjYHbaEPwHPWW/JrU6Atv1d7km/a/Pq49356f+fec+69lRw8eJDwYDGgI6BXQfGgaJAU9DwohL7HANKB/gPNgSZAatAgSMt1BQM4+l4/0FugLFASKNKFz4RQRVJgKYzXHoC6QX+C+kBrbFdYwnKPwEZ8AMoFRXEEGaH8DvoFNC82ELGgItApUCDhx8yg66DvQTM7/TL/iIiInXweu3Ip6AvQa/h9hD/DsvBXzKe+ZoDC8fhe9tTSQL+CCngG4AzIx7Qu6Xz2iOdAn4MqQLuJeGw3dc7om/4GrXLZI/bSe/I0Ea+dpnXcyxUIHNKu0Eexm9t1dRXEIdB3oAjiPRZB63yELRCvgL4FhRLvM6zzN670jO1A4ATpazo8eath3b/abna7FYhdrnyBl1gkbcsuT0Bc9BLH6I4DrXEXRJrIh0hP7R3aNpdAhNDe4Kt2kRH6bwmixEf8wlb+4tPtQMSBPmKz1MOHDwcrlcpDd+7cOVpeXh4lEhgf0rZuGmtU0SiSNWtubo5PSEgIDQwM9Dt+/Pie4OBg0tPToxMYBHaAYFCXsx4RRfMJrNramn0ySaFQRFdWVoqhZ5wijOQRs0coQG+yXdrY2NiyXC6XBQUFbUA/duzYnvX19dXbt2/rBQ7fV2mkugECc5eXaHdh1R49emQB/7CUm5srw9vDdh1ukzCTyYSvGQSEgX7iJ+y4NhCJoHe5Km1ubs589+7dpZycHKkNhkQiIYmJiWF6vR5fEwoG/vD9oBkbiE+INe3FmWm1WrNKpdJlZ2fLAgICJDYYSUlJ4YuLi6aBgYFlgWCY0GnaQNTwEVhNT0+bhoaGnMEIe/LkiXFwcFAIGOGgHxFEDJ1E8WKTk5MmjUajz8jIkDJgSE6ePBk+Pz+/AqBWBIhOf0MQJ+BJBp8l379/3zQ+Pm7IzMyU+fv7b8BISUkJn52dXR4eHuYbxiCCkMOTN/jujzCsGicmJgzYM/z8/J7BwMfU1FQp3EIGtVpt5LE60wjifXjykhBeanR01Ig9ABvPhJGeni6FHqNHWDxV5SmCwHUJwXKRIyMjK+gb0tLSwvH2YMIAUAYAwgcMI4LApTpB85HoIB8+fGhEH2GDgb4Dbxt4TY8OlvNpJoA4t1UKiy+7d+/eMs4nkpOTw2wwcFTJysqS9vf362ZmZkxcgyglwi7ZbRhOqnQ6nRlghFMWz2DAdDy0vb39AYdFB/oRkVlHR8cCjBh2wZhMJuN6hd2MIAxigYB+oa2tbf+BAwd2O/SUJY6LXhYNCLwVWltb48EnvOAQsBnr6+unOC5ejyCeigFCS0vLfgjV7YZxGFaNhYWFaoxRuJ5HIIh5oSFcvnw5Ti6XRzjkMUxFRUXqqakpEw/VmEcQk0KCaGpqis3Ly7PLmi8sLJiKi4vVGJPwVI0JBDEiFITGxsaYM2fO2OUvIRw3KxQKCFA1fMYaagQxKASEurq66LNnz9pt5oAJlaWkpESN026+o08EoeXbT9TU1OwrKCjY5wyCSqXiGwK2XWubUP3FV6kXLlzYC04wmnkNZpOr58+f1wiUrnvWdhuIG3yUWFZWFgUNjmFeMxgMq6WlpWoBE7g3mCBugR5zWRo0NhJAxDpCgGuavr4+oSA8pm3fAGEBXeOqNBgFXqyoqIizBVJoKysra5WVlaO9vb1CLvJco223W/L7mexg5+pmlp+fL6uuro5nQjAajWtVVVWj3d3dQq6BmmmbiSMI9J7X2S4NIMQ5QoBrY11dXUtEWLvOHC0dw/ArxM0dq9uZxWJZZz6vra0d6+zsXBQYwiptq11ixm44J9Y8/+tslajVapdxOwA4xrWGhoZxpVIpNAQ0XO9U2sU8To4p4LYa3ODtq7tmMNP1nmP6wVmGCt/QQnzXWp3lYDZL1d0EXfVBCFc3mzxulbP8klgPl/mKqWmbiLsgMPj5DCNjH4CAbaimbXIbBNosqJxYjyF6q+loG+a2epMr6XxM3JTRodXbbJFC2Db55Oq6hgp0jgic3/Qgz4B1dinx5M4Czzix7rzzBgeqphDGXf2Auytd/4IKifXwqZiHyOLtfIKjeXLKD+fpeDxZAzpKxHPSD2eMl2gMYXH3wztZ+7xJp6o/sB2oefDDdNC6eJxp2+lJYIzpe2kAg3sWXyb8raybaWKlnpa/o1wK24fkcY0CtyK9zWHQJupD8s5uOfzbhGzQCRagYON7QH8Qjv42gav/j8CK3qJCw8x1ArGeq9oPwjUNKXW0IdS5YUSIWSs99fiTdBj8h/DwRxr/CzAA1VxYGWYkZpUAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
}
.video-wrap[data-v-e6fd6dd0] {
  position: fixed;
  top: 0;
  z-index: 999999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.video-wrap .video-pop[data-v-e6fd6dd0] {
  position: relative;
  top: 50%;
  width: 95%;
  height: 240px;
  padding: 3%;
  margin: auto auto;
  margin-top: -120px;
  -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.9);
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.9);
}
.video-wrap .video-pop video[data-v-e6fd6dd0] {
  width: 100%;
  height: 100%;
}
.video-wrap .video-pop .video-close[data-v-e6fd6dd0] {
  position: absolute;
  top: -35px;
  right: 15px;
  display: block;
  float: none;
  width: 27px;
  height: 47px;
  margin: 0 auto;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/main/sponsor.vue